import { render, staticRenderFns } from "./TabelaCapaListas.vue?vue&type=template&id=c0da4584"
import script from "./TabelaCapaListas.vue?vue&type=script&lang=js"
export * from "./TabelaCapaListas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports